import React, { createContext, useContext, useState, useCallback } from 'react';

// Forces the currently matched route to remount whenever the user navigates via
// the sidebar nav/badges or the notification bell — even to the page they are
// already on (where the URL/query may not change enough for React Router to
// remount). This guarantees each page re-fetches fresh data on click instead of
// showing stale data until a full reload (F5).
const NavRefreshContext = createContext({ navNonce: 0, bumpNav: () => {} });

export const NavRefreshProvider = ({ children }) => {
  const [navNonce, setNavNonce] = useState(0);
  const bumpNav = useCallback(() => setNavNonce((n) => n + 1), []);
  return (
    <NavRefreshContext.Provider value={{ navNonce, bumpNav }}>
      {children}
    </NavRefreshContext.Provider>
  );
};

export const useNavRefresh = () => useContext(NavRefreshContext);
